module.exports = __webpack_public_path__ + "img/249-2566f4.png";